import { render, staticRenderFns } from "./IMViewPV.vue?vue&type=template&id=814f5d4c&lang=pug"
import script from "./IMViewPV.vue?vue&type=script&lang=js"
export * from "./IMViewPV.vue?vue&type=script&lang=js"
import style0 from "./IMViewPV.vue?vue&type=style&index=0&id=814f5d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports